import {
  ClientFrameworkEvent,
  ClientTextEvent,
  ExternalToolRequestEvent,
} from '@packages/domains/ai-assistant/data-types';
import {
  ToolPartialEvent,
  ToolStatusEvent,
} from '@packages/systems/ai/agent/shared';

const shouldTextEventShowThinking = (_event: ClientTextEvent) => {
  // Text itself is progress; don't show the generic thinking indicator.
  // This avoids a stale spinner after a completed assistant response.
  return false;
};

const shouldExternalToolCallShowThinking = (
  _event: ExternalToolRequestEvent
) => {
  // Tool call UI already communicates progress/completion.
  return false;
};

const shouldToolStatusShowThinking = (event: ToolStatusEvent) => {
  return event.status !== 'executing';
};

const shouldToolPartialShowThinking = (event: ToolPartialEvent) => {
  return !event.isComplete;
};

export const shouldEventShowThinking = (
  event: ClientFrameworkEvent | undefined
) => {
  let shouldShowThinking = false;
  if (!event) return false;
  if (event.type === 'user_input') {
    shouldShowThinking = true;
  } else if (event.type === 'text') {
    shouldShowThinking = shouldTextEventShowThinking(event);
  } else if (event.type === 'external_tool_call') {
    shouldShowThinking = shouldExternalToolCallShowThinking(event);
  } else if (event.type === 'tool_status') {
    shouldShowThinking = shouldToolStatusShowThinking(event);
  } else if (event.type === 'tool_partial') {
    shouldShowThinking = shouldToolPartialShowThinking(event);
  } else if (event.type === 'error') {
    shouldShowThinking = false;
  }

  return shouldShowThinking;
};
